import React from 'react';
import { withRouter} from 'react-router-dom';
import CookieConsent from "react-cookie-consent";

import LandingLayout from 'component/page/landing';
import Hero from 'component/content/hero';
// import CTA from 'component/content/cta';
// import SubscribeCTA from 'component/content/subscribe';
import Features from 'component/content/features';
import EarlyAccessCTA from 'component/content/early_access';
import Quotes from 'component/content/quotes';
import BBPromo from 'component/content/bb_promo';
import Popular from 'component/content/popular';


class Page extends React.Component {
  render (){
    return (
      <LandingLayout id="landing-page">
        <CookieConsent>
          This website uses cookies to enhance the user experience.
        </CookieConsent>

        <Hero />

        <Quotes />

        {/* <hr className="my-5"/> */}
        <Features />
        <Popular />

        {/* <div className="slant slant-top-left-dark-2"></div>
        <div className="content-section gradient-dark-2">
        </div> */}
          {/* <CTA /> */}
        <div className="bg-dark">
          <EarlyAccessCTA text_colour="white"/>
        </div>


        <BBPromo />

      </LandingLayout>
    )
  }
}

export default withRouter(Page);
